/** Presentation changes never grant permissions or change business data. */
export const productFields = {
  name: 'Nome',
  price: 'Preço',
  image: 'Foto',
  category: 'Categoria',
  description: 'Descrição',
  specifications: 'Informações do produto',
  sizeGuide: 'Tabela de medidas',
  unit: 'Unidade',
  sku: 'SKU',
  barcode: 'Código de barras',
  cost: 'Custo',
  attributes: 'Atributos das variações',
} as const;
export type ProductField = keyof typeof productFields;
export const productColumns = {
  name: 'Produto',
  category: 'Categoria',
  variants: 'Variações',
  price: 'Preço',
  codes: 'Códigos',
} as const;
export type ProductColumn = keyof typeof productColumns;
export interface ProductPresentation {
  view?: 'cards' | 'table';
  version: 1;
  fields: ProductField[];
  columns: ProductColumn[];
  density: 'comfortable' | 'compact';
  category: string;
  order: 'name' | 'name-desc';
}
export const presentationTemplates: Record<
  'complete' | 'fashion' | 'workshop',
  { label: string; config: ProductPresentation }
> = {
  complete: {
    label: 'Completo',
    config: {
      version: 1,
      fields: Object.keys(productFields) as ProductField[],
      columns: ['name', 'category', 'variants', 'price', 'codes'],
      density: 'comfortable',
      category: '',
      order: 'name',
    },
  },
  fashion: {
    label: 'Moda',
    config: {
      version: 1,
      fields: [
        'name',
        'price',
        'image',
        'category',
        'description',
        'specifications',
        'sizeGuide',
        'sku',
        'barcode',
        'attributes',
      ],
      columns: ['name', 'category', 'variants', 'price'],
      density: 'comfortable',
      category: '',
      order: 'name',
    },
  },
  workshop: {
    label: 'Impressão 3D e produção',
    config: {
      version: 1,
      fields: ['name', 'price', 'description', 'unit', 'cost', 'attributes'],
      columns: ['name', 'variants', 'price'],
      density: 'compact',
      category: '',
      order: 'name',
    },
  },
};
export interface PresentationState {
  scope?: 'company' | 'owner' | 'admin' | 'personal';
  inherited?: boolean;
  revision: number;
  config: ProductPresentation;
  history: { revision: number; config: ProductPresentation | null; actor: string; at: string }[];
}
